<template>
  <div id="app">
    <router-view :key="appI18nKey"/>
    <BaseNotification
        :pendingCountData="pendingCountData"
        @closePrepayment="closePrepayment"
        v-if="messageStatus"></BaseNotification>
  </div>
</template>
<script>
import { I18n_api, getlanglist, getSysInternationalList, searchMessageApi } from "@public/api";
import { mapGetters, mapMutations, mapActions } from "vuex";
import bus from "@/common/bus.js";
import debounce from "lodash/debounce";
import BaseNotification from "./components/BaseNotification/BaseNotification.vue";

export default {
  components: { BaseNotification },
  data() {
    return {
      appI18nKey: new Date().getTime(),
      NODE_ENV: process.env.NODE_ENV,
      routerList: ['/login', '/welcomePage', '/home', '/noPermission', '/404']
    };
  },
  computed: {
    ...mapGetters(['token', 'messageStatus', 'lang', 'pendingCountData'])
  },
  watch: {
    // 监听国际化语种字段，有更新且不为空时重新获取国际化数据，同时更新缓存中的国际化数据
    lang: {
      handler(val, nval) {
        console.log(val, nval, 'val, nval')
        if (val && val !== nval) {
          this.getI18nData(val);
        }
      },
      // 初始化的时候执行
      immediate: false
    },
    $route: {
      handler(val) {
        /* 不在白名单列表的不参与动态计算表格高度 */
        if (!this.routerList.includes(val.path)) {
          this.calcTableHeight()
        }
      }
    },
    token: {
      handler(val, nval) {
        if (val && val !== nval) {
          this.GET_NOTIFICATION()
          clearInterval(this.timer)
          /* 当登录成功启动定时器半个小时调一次接口 */
          this.timer = setInterval(() => {
            this.GET_NOTIFICATION()
          }, 1800000)
        } else {
          clearInterval(this.timer)
        }
      },
      // 初始化的时候执行
      immediate: true
    }
  },
  created() {
    if (this.token) {
      this.GET_NOTIFICATION()
    }
  },
  mounted() {
    this.initI18nData();
    this.$nextTick(() => {
      // this.calcTableHeight()
      // 绑定窗口resize事件
      const fn = debounce(this.calcTableHeight, 200); // 表格高度计算防抖
      window.addEventListener("resize", fn, false);
      // 触发destroyed钩子，移除resize的监听事件
      this.$once("hook:destroyed", () => {
        window.removeEventListener(
          "resize",
          debounce(this.calcTableHeight, 200),
          false
        );
      });
    })
  },
  beforeRouteLeave(to, from, next) {
    bus.$off("doLayout");
    next();
  },
  destroyed() {
    // 清除定时任务/绑定事件/eventBus事件
    // window.removeEventListener('resize', debounce(this.calcTableHeight, 200), false)
    // console.info('aaaa3========= destroyed Vue 实例销毁后调用222', this)
  },
  methods: {
    ...mapMutations(["SET_DEFAULT_LANG", "SET_LANG_JSON", "SET_LANG_LIST", 'SET_STATUS']),
    ...mapActions({
      setTableHeight: "setTableHeight",
      GET_NOTIFICATION: "GET_NOTIFICATION"
    }),
    calcTableHeight() {
      setTimeout(() => {
        if (document.getElementById("jmsSearch") !== null) {
          this.restHeight = document.getElementById("jmsSearch").clientHeight;
          this.btnHeight = document.getElementById("jmsTopMenu").clientHeight
          this.clientHeight = document.documentElement.clientHeight;
          const tableHeight = this.clientHeight - this.restHeight - this.btnHeight - 160;
          this.setTableHeight(tableHeight);
        }
      }, 800)
    },
    // 初始化系统国际化数据
    async initI18nData() {
      // 语言列表
      this.getLangList();
      // 获取本地语言信息
      const lan = localStorage.getItem("lang");
      // 本地语种存在
      if (lan) {
        // 更新store中默认语言
        this.SET_DEFAULT_LANG(lan);
      } else {
        // 获取数据库的默认语种信息
        await this.getDefaultLang();
      }
      this.$nextTick(() => {
        // 获取国际化数据
        this.lang && this.getI18nData(this.lang);
      });
    },
    //  获取默认语言
    async getDefaultLang() {
      try {
        const { code, msg, data = "" } = await I18n_api();
        if (code === 1 && data) {
          // 更新store中的系统当前语言
          this.SET_DEFAULT_LANG(data);
        } else {
          console.error(msg);
        }
      } catch (error) {
        console.error("getI18nData::error", error);
      }
    },
    // 获取语言列表
    async getLangList() {
      try {
        const { code, msg, data = [] } = await getlanglist();
        if (code === 1) {
          // 更新store中语言列表
          this.SET_LANG_LIST(data);
        } else {
          console.error(msg);
        }
      } catch (error) {
        console.error("getI18nData::error", error);
      }
    },
    // 获取国际化数据
    async getI18nData(lang) {
      try {
        const { code, msg, data = {}} = await getSysInternationalList();
        if (code === 1) {
          // 更新store中国国际化数据
          this.SET_LANG_JSON(data);
          // 更新页面 防止国际化失败
          window._COLLECT_LIST = []; // 清除 国际化收集
          this.appI18nKey = new Date().getTime();
        } else {
          console.error("getI18nData::fail", msg);
        }
      } catch (error) {
        console.error("getI18nData::error", error);
      }
    },
    /* 改变未读消息的状态 */
    async closePrepayment(id) {
      const { code, succ } = await searchMessageApi.changeUnreadMessageStatus({ ids: [id] });
      if (code === 1 && succ) {
        this.GET_NOTIFICATION()
      }
    }
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

html,
body,
#app,
.wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f6f6f6;
}

body {
  @include scrollBarStyle();
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "microsoft yahei",
    arial, STHeiTi, sans-serif;
}

a {
  text-decoration: none;
}
.main-wrap {
  @include scrollBarStyle();
  background: #ffffff;
  border: 1px solid #ece8e8;
  // border-radius: 13px;
  height: 100%;
  box-sizing: border-box;
  padding: 24px 36px 0;
  overflow: auto;
}
body .el-table__body tr.current-row > td {
  background-color: inherit;
  // background-color: #e7e7f0;
}

.login_box input::-webkit-input-placeholder {
  font-size: 18px;
  color: #c0c0c7;
}
.login_box input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 18px;
  color: #c0c0c7;
}
.login_box input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-size: 18px;
  color: #c0c0c7;
}
.login_box input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  font-size: 18px;
  color: #c0c0c7;
}
// 兼容输入框 选中输入出现背景色问题
input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  background-color: rgb(0, 0, 0) !important;
  background-image: none !important;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
}
.el-message-box__title {
  font-weight: bolder;
}
.el-message-box__content {
  font-size: 16px !important;
  margin-left: 20px;
}
.el-date-table td.disabled div {
  background: #f6f6f6 !important;
}
.tip.el-popover{
    border-radius: 2px !important;
    background-color: #303133 !important;
    color: #fff !important;
}
.tip.el-popover .popper__arrow::after {
	/* 注意：placement位置不同，下面的属性不同 */
    border-right-color: #303133 !important;
}
.tip.el-popover--plain{
  padding: 4px 10px !important;
}
.el-dialog__header{
  border:none !important
}
.el-dialog__body{
  padding-top: 20px !important;
}
.el-drawer__body{
  overflow: auto;
}

input:-webkit-autofill , textarea:-webkit-autofill, select:-webkit-autofill {
  -webkit-text-fill-color: #ededed !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color:transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s; //背景色透明 生效时长 过渡效果 启用时延迟的时间
}
input {
  background-color:transparent;
}
.avue-detail__item--inline{
  width: 94% !important;
  word-wrap: break-word;
  word-break:break-all
}
.avue-detail__content{
  word-wrap:break-word !important;
}
.el-popover.recipientPop{
  padding: 12px 0;
  .recipientSelect {
    list-style: none;
    li:hover {
      background-color: #e7e7f0;
      cursor: pointer;
    }
    li {
      display: flex;
      padding: 8px 12px;
      .detail-info {
        flex: 1;
        line-height: 1.6;
      }
    }
  }
  .footer-btn {
    padding: 12px;
    text-align: right;
    border-top: 1px solid #CCCCCC;
  }
  .empty {
    margin: 0;
    text-align: center;
    color: #999;
    font-size: 14px;
  }
}
.el-scrollbar__wrap {
  overflow-x: hidden !important;
}
.el-select-dropdown__wrap.el-scrollbar__wrap {
  margin-bottom: 0!important;
}
</style>
